module.exports = __webpack_public_path__ + "img/page-bg.13b51cd8.png";